import Vue from "vue";
import { mapGetters } from "vuex";
import { themeHelper }     from "@/components/mixins/themeHelper";
import { faEnvelope, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default Vue.extend({
    name: "ImageGallery",
    mixins: [themeHelper],
    components: {
        FontAwesomeIcon,
    },
    computed: {
        ...mapGetters(["getContentItem"]),
        haveActualPartImages(){
            var haveActualPartImages = this.successfulImages.length > 0 && 
                this.successfulImages.length === this.numberOfImagesLoaded
                && !( this.successfulImages[0] == "NoImageAvailable" && this.successfulImages.length === 1);
            return haveActualPartImages;
        }
    },
    props: {
        galleryImages: {
            type: Array,
            default: () => [],
        },
        oemPartCode: {
            type: String,
            default: "",
        },
        emailAction: Function,
        printAction: Function,
    },
    data: () => ({
        slide: 0,
        printIcon: faPrint,
        emailIcon: faEnvelope,
        successfulImages: [],
        numberOfImagesLoaded: 0,
        showRequestPicturesSuggestion: false,
        zoomFactor: 2.5,
        zoomActive: false,
        zoomPanelStyle: {},
        zoomLensStyle: {},
    }),
    created(){
        this.successfulImages = this.galleryImages;
        this.showRequestPicturesSuggestion = this.successfulImages.length === 1 && this.successfulImages[0] === "NoImageAvailable";
    },
    methods: {
        goToSlide(index: number){
            this.$refs.carousel.setSlide(index);
        },

        goToPrevSlide(){
            this.$refs.carousel.prev();
        },

        goToNextSlide(){
            this.$refs.carousel.next();
        },

        getImageSrc(image: string){
            if(image == "NoImageAvailable"){
                return this.getImage("partNoImageAvailable");
            }
            return image;
        },

        removeImage(index: number){
            this.successfulImages = this.successfulImages.splice( index, 1 );
        },

        onZoomMove(event: MouseEvent) {
            const area = this.$refs.zoomArea as HTMLElement;
            const img = area.querySelector(".carousel-item.active img") as HTMLImageElement;
            if (!this.haveActualPartImages || !img) {
                this.zoomActive = false;
                return;
            }

            const imgRect = img.getBoundingClientRect();
            const x = event.clientX - imgRect.left;
            const y = event.clientY - imgRect.top;
            if (x < 0 || y < 0 || x > imgRect.width || y > imgRect.height) {
                this.zoomActive = false;
                return;
            }

            const areaRect = area.getBoundingClientRect();
            const factor = this.zoomFactor;
            const lensW = Math.min(imgRect.width, areaRect.width / factor);
            const lensH = Math.min(imgRect.height, areaRect.height / factor);
            const lensX = Math.max(0, Math.min(x - lensW / 2, imgRect.width - lensW));
            const lensY = Math.max(0, Math.min(y - lensH / 2, imgRect.height - lensH));
            const src = (img.currentSrc || img.src).replace(/"/g, "%22");

            this.zoomLensStyle = {
                width: `${lensW}px`,
                height: `${lensH}px`,
                left: `${imgRect.left - areaRect.left + lensX}px`,
                top: `${imgRect.top - areaRect.top + lensY}px`,
            };
            this.zoomPanelStyle = {
                width: `${areaRect.width}px`,
                height: `${areaRect.height}px`,
                backgroundImage: `url("${src}")`,
                backgroundSize: `${imgRect.width * factor}px ${imgRect.height * factor}px`,
                backgroundPosition: `${-lensX * factor}px ${-lensY * factor}px`,
            };
            this.zoomActive = true;
        },

        onZoomLeave() {
            this.zoomActive = false;
        },

        emailClicked() {
            this.emailAction();
        },

        printClicked() {
            this.printAction();
        },
    },
});
